export default __webpack_public_path__ + "static/media/JPEG.0395d4aa.svg";